import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mb-button',
    templateUrl: './mb-button.component.html',
    styleUrls: ['./mb-button.component.scss'],
    standalone: false
})
export class MbButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
